// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__nVI-J","textarea":"Textarea_textarea__0TJ1b","label":"Textarea_label__oPpkB","limit":"Textarea_limit__zg-l3"};